
import * as React from 'react';
import { colors } from '../colors/color';
import { ISelectionStats, ScoredSelectionStats, SurveyQuestion } from '../../amorg-common';
import { RadialPctChart } from './RadialPctChart';
import { surveyQuestionHelper } from '../../amorg-common/helpers/surveyQuestionHelper';
import { RadialPieChart } from './RadialPieChart';

const smallDim = '64px';
const smallFontSize = '10px';

export function NoDataSurveyAnswerScoreRadialChart(props:{small?:boolean}):JSX.Element
{
    return <RadialPctChart pct={0} hidePct dim={props.small ? smallDim : undefined} fontSize={props.small ? smallFontSize : undefined} />;
}

export function SurveyQuestionAnswerScoreRadialChart(props:{question:SurveyQuestion, stats:ISelectionStats, small?:boolean}):JSX.Element
{
    if(props.stats.totalSelections === 0)
    {
        return <NoDataSurveyAnswerScoreRadialChart small={props.small} />;
    }
    else if(surveyQuestionHelper.isScoredQuestion(props.question))
    {
        return <ScoredSurveyAnswerScoreRadialChart stats={props.stats as ScoredSelectionStats} small={props.small} />;
    }
    else
    {
        return <NonScoredSurveyAnswerScoreRadialChart stats={props.stats} small={props.small} />;
    }
}

export function AggregatedSurveyAnswerScoreRadialChart(props:{stats:ISelectionStats, small?:boolean}):JSX.Element
{
    if(props.stats.totalSelections === 0)
    {
        return <NoDataSurveyAnswerScoreRadialChart small={props.small} />;
    }
    else 
    {
        if(props.stats instanceof ScoredSelectionStats)
        {
            return <ScoredSurveyAnswerScoreRadialChart stats={props.stats} small={props.small} />;
        }
        else
        {
            return <NonScoredSurveyAnswerScoreRadialChart stats={props.stats} small={props.small} />;
        }
    }
}







// ------------These are helpers--------------------------------------------------------------
function ScoredSurveyAnswerScoreRadialChart(props:{stats:ScoredSelectionStats, small?:boolean}):JSX.Element
{
    return <RadialPctChart pct={props.stats.score.agreePlusPct} dim={props.small ? smallDim : undefined} fontSize={props.small ? smallFontSize : undefined} />
}

function NonScoredSurveyAnswerScoreRadialChart(props:{stats:ISelectionStats, small?:boolean}):JSX.Element
{
    const data:{value:number, color:string, legendText:string}[] = 
        props.stats.data.optionValueCounts.map((option,index) =>
        {
            return {
                value:option.count,
                color:colors.indexed.dark[index % colors.indexed.dark.length],
                legendText:""
            }
        }
    );

    return <RadialPieChart segments={data} value="" dim={props.small ? smallDim : undefined} fontSize={props.small ? smallFontSize : undefined} />
}